import Icon from "src/shared/icons"
import ProgressBarUI from "src/shared/components/data-display/AvatarProgressCard/UI/ProgressBarUI/ProgressBarUI"
import { useVentaEnLineaCountdown } from "src/pages/home/components/RoomCard/hooks/useVentaEnLineaCountdown"

import "src/shared/components/data-display/AvatarProgressCard/AvatarProgressCard.css"
import "src/shared/components/data-display/AvatarProgressCard/UI/ProgressBarTimerUI/ProgressBarTimerUI.css"
import "./TiempoRestante.css"

// Tiempo que le queda al huésped de venta en línea para hacer check in
const TiempoRestante = ({ dateStatusChanged, dateEnd }: { dateStatusChanged?: string; dateEnd?: string }) => {
    const { timeLeft, percentElapsed } = useVentaEnLineaCountdown(dateStatusChanged, dateEnd)

    return (
        <div className="avatar-progress-card room-detail--venta-en-linea__tiempo">
            <div className="avatar-progress-card__description">
                <Icon name={"Stopwatch"} color="var(--white)" height={14} width={14} />
                <span className="avatar-progress-card__description-text">Tiempo restante</span>
            </div>
            <div className="avatar-progress-card-timer__container">
                <div className="room-detail--venta-en-linea__tiempo__timer">
                    <span className="avatar-progress-card-timer" style={{ width: percentElapsed }}>
                        {timeLeft}
                    </span>
                </div>
                <ProgressBarUI percentValue={percentElapsed} percentExtraTime="0%" />
            </div>
        </div>
    )
}

export default TiempoRestante
